(function () {
  'use strict';

  angular
    .module('missingEtsReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('missingEtsReport', {
        url: '/missing-ets-report',
        views:{
          'missingEtsReportView': {
            templateUrl: 'missing-ets-report/views/missing-ets-report.tpl.html',
            controller: 'MissingEtsReportCtrl',
            controllerAs: 'missingEtsReport'
          }
        }
      });
  }
}());
